import React from 'react'
import Logo from '../common/Logo'

function LegalLayout({ title, children, onRetour }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: 'Inter, -apple-system, sans-serif' }}>
      <header style={{ background: 'white', borderBottom: '1px solid #e2e8f0', padding: '0 24px', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Logo size="md" withText={true} />
        <button onClick={onRetour} style={{ background: 'none', border: '1.5px solid #e2e8f0', borderRadius: 8, padding: '7px 16px', fontSize: 13, cursor: 'pointer', color: '#4a5568' }}>
          Retour
        </button>
      </header>
      <main style={{ maxWidth: 760, margin: '48px auto', padding: '0 24px 80px' }}>
        <h1 style={{ fontSize: 30, fontWeight: 800, color: '#0f172a', marginBottom: 8 }}>{title}</h1>
        <p style={{ fontSize: 13, color: '#a0aec0', marginBottom: 40 }}>Version en vigueur depuis le {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
        <div style={{ background: 'white', borderRadius: 14, padding: '40px 48px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', lineHeight: 1.75, color: '#374151', fontSize: 15 }}>
          {children}
        </div>
      </main>
    </div>
  )
}

function H2({ children }) {
  return <h2 style={{ fontSize: 18, fontWeight: 700, color: '#0f172a', marginTop: 36, marginBottom: 10, borderBottom: '2px solid #e8f7f2', paddingBottom: 8 }}>{children}</h2>
}
function P({ children }) {
  return <p style={{ marginBottom: 14 }}>{children}</p>
}

export default function CGV({ onRetour }) {
  return (
    <LegalLayout title="Conditions Generales de Vente" onRetour={onRetour}>
      <H2>Article 1 — Objet et champ d application</H2>
      <P>Les presentes Conditions Generales de Vente (CGV) regissent l ensemble des relations contractuelles entre la societe <strong>[NOM DE LA SOCIETE]</strong> (ci-apres "le Prestataire"), editrice du service Suiveo BTP, et toute personne physique ou morale souhaitant souscrire a un abonnement payant (ci-apres "le Client").</P>
      <P>Seuls les comptes de type "Architecte / Maitre d oeuvre" sont soumis aux presentes CGV. L acces Entreprise et l acces Client sont entierement gratuits et ne font pas l objet d une relation commerciale payante.</P>

      <H2>Article 2 — Description du service</H2>
      <P>Suiveo BTP est une plateforme SaaS (Software as a Service) de suivi de chantier accessible via navigateur web. Le service comprend notamment :</P>
      <ul style={{ paddingLeft: 24, marginBottom: 14 }}>
        {['Creation et gestion illimitee de chantiers','Generation de codes acces uniques par chantier','Invitation des entreprises membres','Acces client en lecture seule via code','Messagerie interne et client par chantier','Gestion des taches, photos et documents','Tableau de bord de suivi en temps reel'].map((f, i) => (
          <li key={i} style={{ marginBottom: 6 }}>{f}</li>
        ))}
      </ul>

      <H2>Article 3 — Tarification</H2>
      <P>L abonnement Architecte est facture <strong>20 euros TTC par mois</strong>, sans engagement de duree minimale. Le prix est susceptible d evoluer ; toute modification sera notifiee au Client 30 jours avant son entree en vigueur.</P>
      <P>La premiere periode d abonnement est offerte : 30 jours d essai gratuit a l activation du compte.</P>

      <H2>Article 4 — Duree et renouvellement</H2>
      <P>L abonnement est souscrit pour une periode d un mois calendaire, renouvelable tacitement a son terme. Le Client peut resilier a tout moment depuis son espace personnel, sans frais, avec effet a la fin de la periode en cours.</P>

      <H2>Article 5 — Paiement</H2>
      <P>Le paiement est effectue par <strong>[mode de paiement : carte bancaire, virement, etc.]</strong> via notre prestataire de paiement securise <strong>[NOM DU PRESTATAIRE — ex : Stripe]</strong>. [NOM DE LA SOCIETE] ne stocke aucune donnee bancaire.</P>
      <P>En cas de defaut de paiement, l acces au service sera suspendu 7 jours apres relance et sans reponse du Client.</P>

      <H2>Article 6 — Droit de retractation</H2>
      <P>Conformement a l article L.221-28 du Code de la consommation, le droit de retractation ne peut etre exerce pour les prestations de services entierement executees avant la fin du delai de retractation. Toutefois, le Client beneficie de la periode d essai de 30 jours pour evaluer le service sans frais.</P>

      <H2>Article 7 — Disponibilite du service</H2>
      <P>Le Prestataire s engage a maintenir le service accessible 24h/24 et 7j/7, sauf interruptions planifiees pour maintenance (notifiees en avance dans la mesure du possible) ou cas de force majeure. La disponibilite ciblee est de 99% par mois.</P>

      <H2>Article 8 — Responsabilite et garanties</H2>
      <P>Le Prestataire est tenu d une obligation de moyens concernant la disponibilite et la securite du service. Sa responsabilite ne saurait etre engagee en cas de perte de donnees due a une faute de l utilisateur, d un tiers ou d un cas de force majeure.</P>
      <P>La responsabilite totale du Prestataire est limitee au montant des abonnements effectivement payes par le Client au cours des 12 derniers mois.</P>

      <H2>Article 9 — Donnees et confidentialite</H2>
      <P>Le Prestataire traite les donnees personnelles du Client conformement a sa Politique de confidentialite et au RGPD. Les donnees metier (chantiers, taches, photos, documents) appartiennent au Client et peuvent etre exportees sur demande.</P>
      <P>En cas de resiliation, les donnees sont conservees 90 jours puis supprimees definitivement, sauf obligation legale contraire.</P>

      <H2>Article 10 — Droit applicable et litiges</H2>
      <P>Les presentes CGV sont soumises au droit francais. En cas de litige, les parties s engagent a rechercher une solution amiable avant tout recours judiciaire. A defaut d accord, le litige sera soumis aux tribunaux competents du ressort de <strong>[VILLE DU SIEGE SOCIAL]</strong>.</P>

      <H2>Article 11 — Contact</H2>
      <P>Pour toute question relative aux presentes CGV : <strong>legal@chantierpro.fr</strong><br />
      [NOM DE LA SOCIETE] — [ADRESSE] — [SIRET]</P>
    </LegalLayout>
  )
}
